import React, { FormEvent, useEffect, useState } from 'react';
import InputFieldText from '../../../components/input/floating-label/input-field/InputFieldText';
import Button, { ButtonType } from '../../../components/button/Button';
import { StateModel, StateModel_Maut } from '../../../redux/store';
import { connect } from 'react-redux';
import {
  getMautLaender,
  mautBerechnung,
  setAnfrageGestartet,
} from '../../../redux/actions/maut';
import Select from '../../../components/select/Select';
import GridCellWrapper from '../../../components/grid-cell-wrapper/GridCellWrapper';
import { toSelectOptions } from '../../../components/select/SelectModel';
import { nameof } from '../../../utils/objectUtils';
import { MautberechnungParam } from '../../../api';
import InputFieldCurrency from '../../../components/input/floating-label/input-field/InputFieldCurrency';
import { ConfigModel } from '../../../models/ConfigModel';

export interface MautrechnerProps {
  getMautLaender: () => void;
  maut: StateModel_Maut;
  mautBerechnung: (
    abgLKZ: string,
    abgPlz: string,
    empLKZ: string,
    empPlz: string,
    gewicht: string
  ) => void;
  setAnfrageGestartet: (value: boolean) => void;
  clientInfobox: string | undefined;
  config: ConfigModel;
}

const Mautrechner = (props: MautrechnerProps) => {
  // Mautberechnung
  const [gewicht, setGewicht] = useState('0');
  const [abgPlz, setAbgPLZ] = useState('');
  const [empPlz, setEmpPLZ] = useState('');
  const [abgLandId, setAbgLandId] = useState(0);
  const [empLandId, setEmpLandId] = useState(0);
  const [maut, setMaut] = useState('');
  const [showAbsPLZ, setShowAbsPLZ] = useState(false);
  const [showEmpPLZ, setShowEmpPLZ] = useState(false);

  let abgLKZ = '';
  let empLKZ = '';

  const onMautSubmit = (e?: FormEvent) => {
    props.setAnfrageGestartet(true);
    abgLKZ =
      props.maut.mautlaender.find(land => land.id === abgLandId)?.lkz ?? '';
    empLKZ =
      props.maut.mautlaender.find(land => land.id === empLandId)?.lkz ?? '';
    props.mautBerechnung(abgLKZ, abgPlz, empLKZ, empPlz, gewicht);

    e?.preventDefault();
  };
  useEffect(() => {
    props.getMautLaender();
  }, []);

  useEffect(() => {
    setAbgPLZ('');
    const plzlaenge =
      props.maut.mautlaender.find(land => land.id === abgLandId)?.plzlaenge ??
      0;
    setShowAbsPLZ(plzlaenge > 0);
  }, [abgLandId]);

  useEffect(() => {
    setEmpPLZ('');
    const plzlaenge =
      props.maut.mautlaender.find(land => land.id === empLandId)?.plzlaenge ??
      0;
    setShowEmpPLZ(plzlaenge > 0);
  }, [empLandId]);

  useEffect(() => {
    setMaut(props.maut.mautbetrag ? props.maut.mautbetrag.toString() : '');
  }, [props.maut.mautbetrag]);

  const getInfotext = () => {
    const htmlstring = props.clientInfobox ?? '';
    return <div dangerouslySetInnerHTML={{ __html: htmlstring }}></div>;
  };

  return (
    <GridCellWrapper classes='erweiterung'>
      {props.clientInfobox && <div className={'bubble'}>{getInfotext()} </div>}
      {props.config.clientKunde?.toUpperCase() === 'BEXITY' && (
        <div className='anforderung'>
          <h2>Sendungskriterien </h2>
          <h3>
            Bitte nur Sendungen erfassen, die folgende Kriterien erfüllen:
          </h3>
          <ul>
            <li>Max. 5 Palettenstellplätze</li>
            <li>Max. 3.000 kg</li>
            <li>Max. 2 Lademeter pro Position</li>
            <li>
              Max. 10m<sup>3</sup>
            </li>
          </ul>
          <h3>Ihre Sendung ist größer?</h3>
          <span>
            Melden Sie sich bitte bei der Charterabteilung ihres zuständigen LCs
            an.{' '}
            <a
              className='link'
              href='https://austria.raben-group.com/kontakt'
              target='_blank'
              rel='noreferrer'
            >
              Kontakt
            </a>{' '}
          </span>
          <h3>Metro Beschaffung?</h3>
          <span>
            Bei mehr als 9 Paletten kontaktieren Sie bitte das{' '}
            <a className='link' href='mailto:mgl@bexity.com'>
              MGL Ost Team
            </a>
            .
          </span>
          <h3>Technische Fragen?</h3>
          <span>
            Unsere Serviceline steht Ihnen telefonisch unter +43 (0) 504 30-0
            sowie per Mail unter{' '}
            <a className='link' href='mailto:IT.Services@bexity.com'>
              IT.Services@bexity.com
            </a>{' '}
            zur Verfügung.
          </span>
        </div>
      )}
      {props.config.isMautrechner && (
        <form className='maut' onSubmit={e => onMautSubmit(e)}>
          <h3>Mautrechner</h3>
          <table>
            <tbody>
              <tr>
                <td>
                  <Select
                    className='abg'
                    headerTitle='Versand'
                    name={nameof<MautberechnungParam>('abgangLKZ')}
                    onChangeHandler={value => setAbgLandId(value ?? 0)}
                    selectedOptionId={abgLandId}
                    selectData={toSelectOptions(
                      props.maut.mautlaender,
                      'lkz',
                      false,
                      true,
                      'bezeichnung'
                    )}
                  />
                </td>
                <td>
                  {showAbsPLZ && (
                    <InputFieldText
                      label='PLZ'
                      name={nameof<MautberechnungParam>('abgangPlz')}
                      tooltip={
                        'Bitte Postleitzahl ' +
                        props.maut.mautlaender.find(
                          land => land.id === abgLandId
                        )?.plzlaenge +
                        'stellig angeben'
                      }
                      classes='abgplz'
                      maxlength={
                        props.maut.mautlaender.find(
                          land => land.id === abgLandId
                        )?.plzlaenge
                      }
                      onChangeHandler={setAbgPLZ}
                      value={abgPlz}
                    />
                  )}
                </td>
                <td className='wert' rowSpan={2}>
                  <InputFieldCurrency
                    resetValue={''}
                    label='Mautkosten'
                    classes='mautkosten'
                    onChangeHandler={setMaut}
                    value={maut}
                    disabled={true}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <Select
                    className='emp'
                    headerTitle='Empfang'
                    name={nameof<MautberechnungParam>('empfaengerLKZ')}
                    onChangeHandler={value => setEmpLandId(value ?? 0)}
                    selectedOptionId={empLandId}
                    selectData={toSelectOptions(
                      props.maut.mautlaender,
                      'lkz',
                      false,
                      true,
                      'bezeichnung'
                    )}
                  />
                </td>
                <td>
                  {showEmpPLZ && (
                    <InputFieldText
                      label='PLZ'
                      name={nameof<MautberechnungParam>('empfaengerPlz')}
                      tooltip={
                        'Bitte Postleitzahl ' +
                        props.maut.mautlaender.find(
                          land => land.id === empLandId
                        )?.plzlaenge +
                        'stellig angeben'
                      }
                      classes='empplz'
                      maxlength={
                        props.maut.mautlaender.find(
                          land => land.id === empLandId
                        )?.plzlaenge
                      }
                      onChangeHandler={setEmpPLZ}
                      value={empPlz}
                    />
                  )}
                </td>
                <td> </td>
              </tr>
              <tr>
                <td>
                  <InputFieldText
                    label='Frachtpfl. Gewicht (kg)'
                    name={nameof<MautberechnungParam>('gewicht')}
                    classes='gewicht'
                    inputType='number'
                    onChangeHandler={setGewicht}
                    value={gewicht}
                  />
                </td>
                <td>{''}</td>
                <td>
                  <Button
                    type={ButtonType.submit}
                    classes='login-btn'
                    disabled={props.maut.anfrageGestartet}
                  >
                    Berechnen
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
          <div className='message'>{props.maut.message}</div>
          <div className='info'>
            Bitte Versand- und Empfangsland, Postleitzahl und Gewicht angeben,
            um Mautkosten zu berechnen.
          </div>
          <p>
            Angegebene Regeltarife können abweichen. Für genaue Preisangaben für
            Ihre individuellen Bedürfnisse kontaktieren Sie uns bitte ...
            <br />
            <br />
          </p>
        </form>
      )}
    </GridCellWrapper>
  );
};

const mapStateToProps = (state: StateModel) => ({
  maut: state.Maut,
  clientInfobox: state.Config.clientInfobox,
  config: state.Config,
});
export default connect(mapStateToProps, {
  getMautLaender,
  mautBerechnung,
  setAnfrageGestartet,
})(Mautrechner);
